var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Transfers",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.400000006
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transfers-|-Search-Player-|-Loan-Dates-(State-3)",
    transform: "translate(-894.000000, -391.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-36",
    transform: "translate(520.000000, 381.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-34-Copy",
    transform: "translate(210.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(164.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,-2.75604455e-14 C3.58746667,-2.75604455e-14 0,3.58749091 0,8 C0,12.4124897 3.58746667,16 8,16 C12.4125333,16 16,12.4124897 16,8 C16,3.58749091 12.4125333,-2.75604455e-14 8,-2.75604455e-14 L8,-2.75604455e-14 Z M8,0.96969697 C11.8884606,0.96969697 15.030303,4.11156364 15.030303,8.00000485 C15.030303,11.888417 11.8884606,15.0303079 8,15.0303079 C4.11153939,15.0303079 0.96969697,11.888417 0.96969697,8.00000485 C0.96969697,4.11156364 4.11153939,0.96969697 8,0.96969697 L8,0.96969697 Z M8,2.90909091 C7.73221818,2.90909091 7.51515152,3.12615758 7.51515152,3.39393939 L7.51515152,8.00000485 C7.51515152,8.17930182 7.61287273,8.33278061 7.75757576,8.41665939 C8.94196364,9.10029576 10.1376242,9.79103515 11.3257697,10.4772655 C11.5576485,10.6111806 11.858497,10.5349382 11.9924364,10.3030352 C12.1263273,10.0711321 12.042497,9.77782303 11.8106182,9.64393212 L8.48484848,7.7196897 L8.48484848,3.39393939 C8.48484848,3.12615758 8.26778182,2.90909091 8,2.90909091 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.e4c1ca4db89821f4ef4ad9daca9b8ec3.svg";
export { ForwardRef as ReactComponent };